export const delay = (timeout: number) =>
  new Promise(r => setTimeout(r, timeout))
